import { edtiRecipeFunction } from 'services/firebase';

const edit = async (id, recipeContentDataModel) => {
  if (!id) throw new Error('id cannot be empty');
  if (!recipeContentDataModel)
    throw new Error('recipeContentDataModel cannot be empty');

  await edtiRecipeFunction({
    recipeID: id,
    recipeContent: recipeContentDataModel,
  });
};

export default edit;
